import {apiConstants} from "./actions/constants";
import {CompanyData} from "../utils/api";

export class CompaniesApiState {
  companies: CompanyData[] = null;
  fetching: boolean = false;
  fetched: boolean = false;
  error: string = null;
}

export default function reducer(state = new CompaniesApiState(), action) {
  switch (action.type) {
    case apiConstants.companies.pending:
      return {
        ...state,
        fetching: true
      };
    case apiConstants.companies.rejected:
      return {
        ...state,
        fetching: false,
        error: action.payload
      };
    case apiConstants.companies.fulfilled:
      return {
        ...state,
        fetching: false,
        fetched: true,
        companies: action.payload.results
      };
  }

  return state;
}



// WEBPACK FOOTER //
// ./src/redux/companies.js